import { post } from "@/api/config/$ajax";

// application/json
const applicationJson = { appJson: true, submitType: 'json' };

export const reqList = (data) => {
  return post('/item/stock/queryStockUploadLogList', data, applicationJson)
};